"use client";

import React from "react";
import { useNavigate } from "react-router-dom";
import { AuthSideSection } from "@/components/auth/AuthSideSection";

export default function OnboardingIndex() {
  const navigate = useNavigate();

  return (
    <div className="bg-auth-background w-screen h-screen flex">
      <main className="flex flex-row w-full h-full overflow-hidden">
        <AuthSideSection />

        <div className="w-full md:w-1/2 bg-auth-card flex items-center justify-center p-8 md:p-12">
          <div className="w-full max-w-md">
            <div className="animate-fadeInUp">
              <div className="text-center mb-8">
                <img
                  src="/assets/auth/logo.png"
                  alt="Shiphouse Logo"
                  width={90}
                  height={90}
                  className="mx-auto mb-4"
                />
                <h1 className="text-3xl font-semibold text-auth-text mb-2">Create New Store</h1>
                <p className="text-auth-text-muted mt-2">
                  Choose the type of store you want to create to begin onboarding.
                </p>
              </div>

              <div className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <button
                    onClick={() => navigate("/onboarding/seller")}
                    className="w-full p-4 border border-auth-border rounded-xl text-left transition-all duration-300 group bg-auth-surface hover:bg-auth-surface-dark hover:border-primary/30"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                          <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                          </svg>
                        </div>
                        <div>
                          <h3 className="text-auth-text font-medium">Seller Store</h3>
                          <p className="text-auth-text-muted text-sm">Create a store to sell directly to customers.</p>
                        </div>
                      </div>
                      <div className="text-primary group-hover:translate-x-1 transition-transform duration-300">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    </div>
                  </button>

                  <button
                    onClick={() => navigate("/onboarding/wholesaler")}
                    className="w-full p-4 border border-auth-border rounded-xl text-left transition-all duration-300 group bg-auth-surface hover:bg-auth-surface-dark hover:border-primary/30"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                          <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h18v4H3zM3 15h18v6H3z" />
                          </svg>
                        </div>
                        <div>
                          <h3 className="text-auth-text font-medium">Wholesaler Store</h3>
                          <p className="text-auth-text-muted text-sm">Create a store for wholesale buyers and bulk orders.</p>
                        </div>
                      </div>
                      <div className="text-primary group-hover:translate-x-1 transition-transform duration-300">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
